import React from "react";
import Nutrient, {NutrientData} from "./nutrient";
import {useTranslation} from "next-i18next";

/**
 *
 */
type Data = {
    nutrients: NutrientData[]
};

/**
 *
 * @param nutrients
 * @constructor
 */
export default function NutrientList ({ nutrients } : Data) {
    // init
    const { t } = useTranslation();
    const defaultDescription = t('no.more.information', { ns: 'glossary' });

    // init the description texts of the nutrients
    nutrients.map((nutrient) => {
        const index = nutrient.name + '.lead';
        const description = t(index, { ns: 'nutrients' });
        nutrient.description = index === description ? defaultDescription : description;
        nutrient.source = '';
    });

    // select macro- and micro-nutrients
    let macroNutrients : NutrientData[];
    macroNutrients = [];
    let microNutrients : NutrientData[];
    microNutrients = [];
    nutrients.map((nutrient) => {
        if('Macro' === nutrient.type) {
            macroNutrients.push(nutrient);
        } else {
            microNutrients.push(nutrient);
        }
    });

    return (
        <>
            <div className="accordion accordion-flush" id="nutrientList">
                {macroNutrients.map((nutrient, index) =>
                    'Macro' === nutrient.type ? <Nutrient key={'nutrient-' + index + '-' + nutrient.id} nutrient={nutrient} /> : ''
                )}
            </div>
            {
                microNutrients.length
                    ?
                    <div className="accordion accordion-flush border-top border-3" id="microNutrientList">
                        {microNutrients.map((nutrient, index) =>
                            ('Macro' !== nutrient.type && nutrient.proportion > 0) ? <Nutrient key={'nutrient-' + index + '-' + nutrient.id} nutrient={nutrient} /> : ''
                        )}
                    </div>
                    :
                    ''
            }
        </>
    );
}